export const ROOT = ""; //"http://113.190.254.209:18689"  //"http://192.168.0.227:8689"; //"http://172.16.3.93:8081"; //;"http://172.16.3.118:8081"; //"http://192.168.0.227:8689";
export const USER_LOGIN = "/api/v2/hotel/login/user";
export const EZID_LOGIN = "/api/v2/hotel/login/user-ez-id";
export const USER_LOGIN_ADMIN = "/api/v2/hotel/login/admin";
export const USER_LOGIN_TOKEN = "/api/v2/hotel/login/user";
export const FORGOT_PASSWORD = "/api/v2/hotel/forgot-password";
export const USER_REGISTER = "/api/v2/hotel/register";
export const REGISTER_DUPPLICATION_API = "/api/v2/hotel/register-dupplication";
export const UPLOAD_CERTIFICATE = "/api/v2/hotel/resource/upload-certificate";
export const USER_UPDATE_CHAT_ID = "/api/v2/hotel/user/chat";

export const HOTEL_DETAIL = "/api/v2/hotel/review/detail";
export const CHANGE_QUANTITY = "/api/v2/hotel/review/change-quantity";
export const GET_LIST_GIFTCODE = "/api/v2/hotel/giftcode/get-list";
export const GET_ROOM_GROUP = "/api/v2/hotel/room/get-room-group";
export const GET_ROOM_PARENT_TYPE = "/api/v2/hotel/room/search-parent";
export const UPDATE_ROOM_STATUS = "/api/v2/hotel/room/update-status";
export const GET_MARKET = "/api/v2/hotel/room/get-market";
export const GET_CHANNEL = "/api/v2/hotel/room/get-channel";
export const UPDATE_ROOM_RATE_PLAN = "/api/v2/hotel/room/room-plan/room-rate/update";
export const ROOM_PLAN_DETAIL_RATE = "/api/v2/hotel/room/room-plan/room-rate/availability"; // calendar

export const RESTRICTION_PACKAGE_GET_ALL = "/api/v2/hotel/restriction-plan/get-all";
export const RESTRICTION_PACKAGE_UPDATE_STATUS = "/api/v2/hotel/restriction-plan/update-status";
export const RESTRICTION_PACKAGE_DELETE = "/api/v2/hotel/restriction-plan/delete";
export const RESTRICTION_PACKAGE_DETAIL = "/api/v2/hotel/restriction-plan/detail";
export const RESTRICTION_PACKAGE_UPDATE = "/api/v2/hotel/restriction-plan/update";
export const RESTRICTION_PACKAGE_CREATE = "/api/v2/hotel/restriction-plan/create";
export const RESTRICTION_GET_ALL = "/api/v2/hotel/restriction/get-all";
export const RESTRICTION_GET_ALL_BY_ROOMTYPE = "/api/v2/hotel/restriction/room-type/get-all";
export const RESTRICTION_GET_ALL_BY_RATEPLAN = "/api/v2/hotel/restriction/rate-plan/get-all";
export const RESTRICTION_GET_ALL_ROOMTYPE_HAS_ROOMRATE = "/api/v2/hotel/restriction/room-type/has-room-rate";
export const RESTRICTION_GET_ALL_ROOMPLAN_HAS_ROOMRATE = "/api/v2/hotel/restriction/rate-plan/has-room-rate";
export const RESTRICTION_GET_ALL_OTA_HAS_ROOMRATE = "/api/v2/hotel/restriction/room-type/has-room-rate";

export const RESTRICTION_BATCH_UPDATE = "/api/v2/hotel/restriction/update";

export const UPDATE_EXTRA_PRICE = "/api/v2/hotel/room-rate/update-extra-rate";
export const MASS_UPDATE_EXTRA_PRICE = "/api/v2/hotel/room-rate/mass-update-extra-rate";

export const UPDATE_SPECIAL_PRICE_EXTRA = "/api/v2/hotel/room-rate/mass-update-extra-special-rate";

export const DELETE_EXTRA_PRICE = "/api/v2/hotel/room-rate/delete-extra-rate";
export const DELETE_SPECIAL_PRICE_BULK = "/api/v2/hotel/room-rate/bulk-delete-price-special";

export const RELATION_GET_ALL = "/api/v2/hotel/room/all-relation";
export const RELATION_ADD_SALE_PACKAGE = "/api/v2/hotel/room-rate/create";
export const RELATION_REMOVE_SALE_PACKAGE = "/api/v2/hotel/room-rate/delete";
export const UPDATE_PRICE = "/api/v2/hotel/room-rate/update-rate";
export const UPDATE_SPECIAL_PRICE = "/api/v2/hotel/room-rate/update-rate-special";
export const UPDATE_SPECIAL_PRICE_ADULT = "/api/v2/hotel/room-rate/update-rate-adult";
export const UPDATE_SPECIAL_PRICE_CHILD = "/api/v2/hotel/room-rate/update-rate-child";
export const UPDATE_SPECIAL_PRICE_BABY = "/api/v2/hotel/room-rate/update-rate-baby";
export const DELETE_SPECIAL_PRICE = "/api/v2/hotel/room-rate/delete-price-special";
export const DELETE_SPECIAL_PRICE_EXTRA_ADULT = "/api/v2/hotel/room-rate/delete-price-special-adult";
export const DELETE_SPECIAL_PRICE_EXTRA_CHILD = "/api/v2/hotel/room-rate/delete-price-special-child";
export const DELETE_SPECIAL_PRICE_EXTRA_BABY = "/api/v2/hotel/room-rate/delete-price-special-baby";



export const SYNCOTA_GET_ALL = "/api/v2/hotel/ota/get-all";
export const SYNCOTA_GET_CONNECTED = "/api/v2/hotel/ota/hotel/get-all";
export const SYNCOTA_CREATE_CONNECT = "/api/v2/hotel/ota/hotel";
export const SYNCOTA_GET_DETAIL = "/api/v2/hotel/ota/hotel";
export const SYNCOTA_UPDATE_DETAIL = "/api/v2/hotel/ota/hotel/update";
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT = "/api/v2/hotel/ota/get-all/not-connect";

export const ALL_LOGS = "/api/v2/hotel/log";

export const GET_ALL_OTA = "/api/v2/hotel/ota-group";
export const GET_ALL_LOCATION = "/api/v2/hotel/location/get-all";
export const GET_ALL_HOTEL_TYPE = "/api/v2/hotel/type/get-all";
export const GET_GENERAL_SETTING = "/api/v2/hotel/hotel-setting/general-info";
export const UPDATE_GENERAL_SETTING = "/api/v2/hotel/hotel-setting/update";

export const GET_POLICY_PAYMENT = "/api/v2/hotel/payment-policy/search";
export const UPDATE_POLICY_PAYMENT = "/api/v2/hotel/payment-policy/update";
export const CREATE_POLICY_PAYMENT = "/api/v2/hotel/payment-policy/create";
export const DELETE_POLICY_PAYMENT = "/api/v2/hotel/payment-policy/delete";

export const SET_SEEN_A_NOTICE = "/api/v2/hotel/notice/seen-message";
export const SET_SEEN_ALL_NOTICE = "/api/v2/hotel/notice/update-seen";

export const GET_CANCELLATION_POLICY =
  "/api/v2/hotel/cancellation-policy/search";
export const UPDATE_CANCELLATION_POLICY =
  "/api/v2/hotel/cancellation-policy/update";
export const CREATE_CANCELLATION_POLICY =
  "/api/v2/hotel/cancellation-policy/create";
export const DELETE_CANCELLATION_POLICY =
  "/api/v2/hotel/cancellation-policy/delete";

export const GET_ALL_CHAIN = "/api/v2/hotel/chain/get-all"; //"/api/v2/hotel/chain";
export const GET_ALL_CHAIN_OF_USER = "/api/v2/hotel/chain/chain-all";
export const GET_ALL_HOTEL_OF_USER = "/api/v2/hotel/chain/hotel-all";
export const GET_DETAIL_HOTEL_CHAIN = "/api/v2/hotel/chain";

export const GET_ALL_HOTEL_AMENITY = "/api/v2/hotel/amenity/get-all";
export const UPDATE_EXTENSION_GENERAL = "/api/v2/hotel/amenity/update";
export const GET_EXTENSION_GENERAL = "/api/v2/hotel/info/amenity";

export const GET_GATEWAY_INFO = "/api/v2/hotel/payment-method/get-all";
export const GET_PAYMENT_GATE = "/api/v2/hotel/payment-method/get-gateway-all";
export const GET_PARAM_PAYMENT = "/api/v2/hotel/gateway/param-payment";
export const GET_SETTING_PAYMENT = "/api/v2/hotel/gateway/setting-payment";
export const UPDATE_PAYMENT_GATE = "/api/v2/hotel/payment-method/update";
//
export const REGIS_PAYMENT_ONLINE = "/api/v2/hotel/payment-method/register";
export const GET_GATEWAY_CONFIG = "/api/v2/hotel/payment-method/get-gateway-config";
export const UPDATE_PARAM = "/api/v2/hotel/payment-method/gateway-update";
export const DEATIVE_METHOD = "/api/v2/hotel/payment-method/deactive";

export const GET_IMAGE_RESOURCE = "/api/v2/hotel/resource/get-images";
export const UPLOAD_IMAGE_RESOURCE = "/api/v2/hotel/resource/upload-image";
export const DELETE_IMAGE_RESOURCE = "/api/v2/hotel/resource/remove";

export const GET_HOTEL_IMAGES = "/api/v2/hotel/info/get-images";
export const UPDATE_HOTEL_IMAGE = "/api/v2/hotel/info/update-image";

//#region dashboard
export const DASHBOARD_REVENUE_STATUS = "/api/v2/hotel/dashboard/revenue-status";
export const DASHBOARD_BOOKING_STATUS = "/api/v2/hotel/dashboard/booking-status";
export const DASHBOARD_HOTEL_STATUS = "/api/v2/hotel/dashboard/hotel-status";
export const DASHBOARD_CONFIRM_HOTEL_INFO = "/api/v2/hotel/dashboard/confirm-hotel-info";
export const DASHBOARD_INFO_STATUS = "/api/v2/hotel/dashboard/info-status";

//#endregion

//#region hotel chain
export const HOTEL_CHAIN_GET_DETAIL = "/api/v2/hotel/chain/get-all";
export const HOTEL_CHAIN_ADD_HOTEL = "/api/v2/hotel/chain/add";
export const HOTEL_CHAIN_REMOVE_HOTEL = "/api/v2/hotel/chain/remove";
export const HOTEL_CHAIN_SAVE = "/api/v2/hotel/chain/update";
export const CHAIN_BOOKING_GET_ALL = "/api/v2/hotel/chain/booking/get-all";
export const CHECK_DUPLICATE_SALE_PACKAGE_CODE = "/api/v2/hotel/plan/code/duplication";
export const SYNCOTA_GET_ALL_CHAIN = "/api/v2/hotel/ota/get-all-chain";
export const CHAIN_BOOKING_DETAIL = "/api/v2/hotel/chain/booking/detail";
export const BOOKING_EXPORT_CHAIN = "/api/v2/hotel/chain/booking/export";


//#endregion

//#region room plan
export const ROOM_PLAN_GET_ALL = "/api/v2/hotel/room-plan/get-all";
export const ROOM_PLAN_GET_ALL_AVAILABLE_RATE = "/api/v2/hotel/room/get-all-avail-rate";
export const ROOM_PLAN_UPDATE_AVAILABLE = "/api/v2/hotel/room/update-avail";
export const ROOM_PLAN_UPDATE_RATE = "/api/v2/hotel/room-plan/update-rate";
export const ROOM_PLAN_UPDATE_STOP_SELL = "/api/v2/hotel/room/update-stop-sell";
export const ROOM_PLAN_UPDATE_CLOSED_TO_ARRIVAL = "/api/v2/hotel/room-plan/update-closed-to-arrival";
export const ROOM_PLAN_UPDATE_CLOSED_TO_DEPATURE = "/api/v2/hotel/room-plan/update-closed-to-departure";
export const ROOM_PLAN_UPDATE_MIN_STAY = "/api/v2/hotel/room-plan/update-min-stay";
export const ROOM_PLAN_UPDATE_MAX_STAY = "/api/v2/hotel/room-plan/update-max-stay";
export const ROOM_PLAN_UPDATE_ALL = "/api/v2/hotel/room-plan/update-all";
export const ALLOTMENT_UPDATE_ALL = "/api/v2/hotel/room/update-cut-off";
export const CONFIRM_PMS = "/api/v2/hotel/room-plan/pms-confirm";
export const ROOM_RATE_PLAN = "/api/v2/hotel/room/room-plan/room-rate";
export const VALIDATE_ROOM_PARENT = "/api/v2/hotel/room/is-children";
export const ROOM_PLAN_UPDATE_STOP_SELL_LIMIT = "/api/v2/hotel/room/update-stop-sell-by-ota";
export const ROOM_PLAN_UPDATE_SELL_LIMIT = "/api/v2/hotel/room/update-sell-limit-by-ota";
export const ROOM_PLAN_DELETE_STOP_SELL_LIMIT = "/api/v2/hotel/room/delete-stop-sell-by-ota";
export const ROOM_PLAN_DELETE_SELL_LIMIT = "/api/v2/hotel/room/delete-sell-limit-by-ota";


//#endregion

//#region booking
export const BOOKING_GET_ALL = "/api/v2/hotel/booking/get-all";
export const REQUEST_GET_ALL = "/api/v2/hotel/request-booking/search";
export const REQUEST_FEEDBACK = "/api/v2/hotel/request-booking/feedback";
export const REQUEST_DETAIL = "/api/v2/hotel/request-booking/detail";
export const BOOKING_EXPORT = "/api/v2/hotel/booking/export";
export const REQUEST_EXPORT = "/api/v2/hotel/request-booking/report";
export const BOOKING_DETAIL = "/api/v2/hotel/booking/detail";
export const BOOKING_CANCEL = "/api/v2/hotel/booking/cancel";
export const BOOKING_TRANSACTION = "/api/v2/hotel/booking/payment/get-all";
export const BOOKING_TRANSACTION_UPDATE = "/api/v2/hotel/booking/payment/update";
export const BOOKING_TRANSACTION_EXPORT = "/api/v2/hotel/booking/payment/export";
export const BOOKING_GETA_ALL_MOBILE = "/api/v2/hotel/mobile/booking/get-all";

export const BOOKING_UNMAP_GET_ALL = "/api/v2/hotel/bookingunmap/get-all";
export const BOOKING_UNMAP_DETAIL = "/api/v2/hotel/bookingunmap/detail";
export const BOOKING_EXPORT_UNMAP = "/api/v2/hotel/bookingunmap/export";
//#endregion

//#region account setting api
export const ACCOUNT_PROFILE_GET_INFO = "/api/v2/hotel/profile/info";
export const ACCOUNT_PROFILE_UPDATE_INFO = "/api/v2/hotel/profile/update";
export const ACCOUNT_PROFILE_UPDATE_PASSWORD = "/api/v2/hotel/profile/password-change";
export const ACCOUNT_PROFILE_RESET_PASSWORD = "/api/v2/hotel/password-reset";
export const ACCOUNT_PROFILE_UPDATE_AVATAR = "/api/v2/hotel/profile/avatar-upload";
export const ACCOUNT_PROFILE_DELETE_AVATAR = "/api/v2/hotel/profile/avatar-delete";
//#endregion

//#region manage user api
export const ACCOUNT_MANAGE_FUNCTION_GET_ALL = "/api/v2/hotel/function/get-all";
export const ACCOUNT_MANAGE_USER_GET_ALL = "/api/v2/hotel/user/get-all";
export const ACCOUNT_MANAGE_USER_DETAIL = "/api/v2/hotel/user/detail";
export const ACCOUNT_MANAGE_USER_CREATE = "/api/v2/hotel/user/add";
export const ACCOUNT_MANAGE_USER_UPDATE = "/api/v2/hotel/user/update";
export const ACCOUNT_MANAGE_USER_DELETE = "/api/v2/hotel/user/delete";
export const ACCOUNT_MANAGE_USER_GET_FUNCTION = "/api/v2/hotel/user/get-function";
export const ACCOUNT_MANAGE_USER_UPDATE_FUNCTION = "/api/v2/hotel/user/update-function";
export const ACCOUNT_MANAGE_USERGROUP_GET_ALL = "/api/v2/hotel/usergroup/get-all";
export const ACCOUNT_MANAGE_USERGROUP_GET_ALL_ACTIVE = "/api/v2/hotel/usergroup/get-all-active";
export const ACCOUNT_MANAGE_USERGROUP_DETAIL = "/api/v2/hotel/usergroup/detail";
export const ACCOUNT_MANAGE_USERGROUP_CREATE = "/api/v2/hotel/usergroup/add";
export const ACCOUNT_MANAGE_USERGROUP_UPDATE = "/api/v2/hotel/usergroup/update";
export const ACCOUNT_MANAGE_USERGROUP_DELETE = "/api/v2/hotel/usergroup/delete";
export const ACCOUNT_MANAGE_USERGROUP_GET_FUNCTION = "/api/v2/hotel/usergroup/get-function";
export const ACCOUNT_MANAGE_USERGROUP_UPDATE_FUNCTION = "/api/v2/hotel/usergroup/update-function";
//#endregion

//#region electrical contract api
export const ACCOUNT_CONTRACT_GET_INFO = "/api/v2/hotel/contract/get-info";
export const ACCOUNT_CONTRACT_UPDATE_INFO = "/api/v2/hotel/contract/update";
export const ACCOUNT_GET_BANK = "/api/v2/hotel/bank/get-all";
export const ACCOUNT_VIEW_CONTRACT = "/api/v2/hotel/contract/export-pdf";
//#endregion

//#region travel agent
export const TRAVEL_AGENT_GET_ALL_ACTIVE = "/api/v2/hotel/travelagent/get-all-active";
export const TRAVEL_AGENT_GET_ALL = "/api/v2/hotel/travelagent/get-all-agent-es";
export const TRAVEL_AGENT_GET_ALL_DEACTIVE = "/api/v2/hotel/travelagent/get-all-deactive";
export const TRAVEL_AGENT_CHANGE_LEVEL = "/api/v2/hotel/travelagent/change-level";
export const TRAVEL_AGENT_ACTIVE = "/api/v2/hotel/travelagent/active";
export const TRAVEL_AGENT_DEACTIVE = "/api/v2/hotel/travelagent/deactive";
//#endregion

//#region area api
export const GET_ALL_LANDMARK = "/api/v2/hotel/area/get-landmark-all";
export const GET_ALL_AREA = "/api/v2/hotel/area/get-all";
export const CREATE_AREA = "/api/v2/hotel/area/create";
export const UPDATE_AREA = "/api/v2/hotel/area/update";
export const DELETE_AREA = "/api/v2/hotel/area/delete";
//#endregion

//#region room infomation
export const GET_ALL_ROOMS_INFO = "/api/v2/hotel/room/get-all";
export const ADD_NEW_ROOW = "/api/v2/hotel/room/create";
export const UPDATE_ROOM = "/api/v2/hotel/room/update";
export const DUPLICATE_ROOM = "/api/v2/hotel/room/copy";
export const DELETE_ROOM = "/api/v2/hotel/room/delete";

export const GET_ROOM_DETAIL = "/api/v2/hotel/room/detail";
export const GET_ROOM_VIEW = "/api/v2/hotel/room/get-views";
export const GET_BED_TYPE = "/api/v2/hotel/room-type/get-bed-type";
export const UPDATE_SALE_PACKAGE_STATUS = "/api/v2/hotel/plan/update-status";


export const GET_ROOM_AMENITIES = "/api/v2/hotel/amenity/amenity-room";
export const UPDATE_ROOM_AMENITIES = "/api/v2/hotel/room/update-amenity";
export const VALIDATE_ROOM_CODE = "/api/v2/hotel/room/code/duplication";
export const GET_ALL_MEAL = "/api/v2/hotel/room/get-meal";
export const GET_PAYMENT_POLICY = "/api/v2/hotel/payment-policy/search";
export const GET_CANCEL_POLICY = "/api/v2/hotel/cancellation-policy/search";
export const GET_APPLY_CARD_TYPE = "/api/v2/hotel/room/get-card";
export const GET_APPLY_FOR_OBJECT = "/api/v2/hotel/room/get-party";


export const GET_ROOM_IMAGE = "/api/v2/hotel/room/images";
export const UPDATE_ROOM_IMAGE = "/api/v2/hotel/room/update-images";
//#endregion

//#region selling room
export const GET_ALL_PLAN = "/api/v2/hotel/plan/get-all";
export const GET_PLAN_DETAIL = "/api/v2/hotel/plan/detail";
export const DELETE_PLAN = "/api/v2/hotel/plan/delete";
export const CREATE_PLAN = "/api/v2/hotel/plan/create";
export const UPDATE_PLAN = "/api/v2/hotel/plan/update";
export const DUPLICATE_PLAN = "/api/v2/hotel/plan/copy";

export const GET_ALL_PROMOTION = "/api/v2/hotel/promotion/get-all";
export const GET_DETAIL_PROMOTION = "/api/v2/hotel/promotion/detail";
export const CREATE_PROMOTION = "/api/v2/hotel/promotion/create";
export const UPDATE_PROMOTION = "/api/v2/hotel/promotion/update";
export const DUPLICATE_PROMOTION = "/api/v2/hotel/promotion/copy";
export const DELETE_PROMOTION = "/api/v2/hotel/promotion/delete";
export const CHANGE_STATUS_PROMOTION = "/api/v2/hotel/promotion/update-status";
export const SORT_INDEX_PROMOTION = "/api/v2/hotel/promotion/change-index";
export const VALIDATE_PROMOTION_CODE = "/api/v2/hotel/promotion/code/duplication";

//#endregion
export const GET_REGISTER_INFO = "/api/v2/hotel/info/general";
export const UPDATE_REGISTER_INFO = "/api/v2/hotel/info/update";

// Activity Diary
export const UPDATE_BULK = "/api/v2/hotel/room-plan-log/search";
export const GET_DETAIL = "/api/v2/hotel/room-plan-log/detail";
export const GET_DETAIL_ROOM_LOG = "/api/v2/hotel/room-log/detail";
export const UPDATE_ROOM_AVAIL = "/api/v2/hotel/room-log/search";
export const GET_ALL_USERS = "/api/v2/hotel/user/get-users-all";
export const GET_ALL_ROOMS = "/api/v2/hotel/room/get-room-all";
export const GET_ALL_ROOM_PLANS = "/api/v2/hotel/room-plan/get-room-plan-all";
export const GET_ALL_ACTIVITY = "/api/v2/hotel/hotel-log/search";

export const USER_SETTING = "api/Users/testauthen";
export const ROLE_ADMIN = "admin";
export const ROLE_USER = "user";
export const MAX_SIZE_IMAGE_UPLOAD = 5242880; // Bytes

// Regex
export const REGEX_UNICODE = /[^ÀÝÂÃÈÉÊÌÝÒÓÔÕÙÚĂĝĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽờờểỄỆỈỊỌỎờỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịờờốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/u;
export const REGEX_PHONE = /^[0-9+( )+]*$/;
export const REGEX_USERNAME = /^[a-z_\.0-9]+$/;
export const REGEX_ENTERPRISE_CODE = /^[0-9-]*$/;
export const REGEX_NUMBER = /^[0-9]*$/;
export const REGEX_MONEY_SIMPLE = /^\$?[1-9]\d?(?:\.\d{2})?$/;
export const REGEX_SERVICE_CODE = /^[a-zA-Z0-9]+$/;
export const REGEX_DISTANCE = /^[-0-9.]*$/;
export const REGEX_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z_\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Service
export const GET_LIST_SERVICE = "/api/v2/hotel/service/list-service";
export const SORT_LIST_SERVICE = "/api/v2/hotel/service/change-index";
export const UPDATE_STATUS_SERVICE = "/api/v2/hotel/service/change-status";
export const DELETE_SERVICE = "/api/v2/hotel/service/delete";
export const DETAIL_SERVICE = "/api/v2/hotel/service/detail";
export const UPDATE_SERVICE = "/api/v2/hotel/service/update";
export const CREATE_SERVICE = "/api/v2/hotel/service/create";
export const CHECK_SERVICE_CODE = "/api/v2/hotel/service/check";
export const CHECK_SPECIAL_DAYS_PRICE = "/api/v2/hotel/service/check-special-service";
export const UPDATE_STATUS_SERVICE_ALL = "/api/v2/hotel/service/change-status-services";
export const DELETE_SERVICE_LIST = "/api/v2/hotel/service/delete-services";
export const GET_ALL_UNIT = "/api/v2/hotel/service/unit";

export const GET_ALL_NEARBY = "/api/v2/hotel/area/get-nearby";

export const GET_EMAIL_TYPE = "/api/v2/hotel/email/type";
export const UPDATE_EMAIL_TYPE = "/api/v2/hotel/email/update-type";
export const DETAIL_EMAIL = "/api/v2/hotel/email/detail";
export const UPDATE_EMAIL = "/api/v2/hotel/email/update";
export const EMAIL_TEST = "/api/v2/hotel/email/send-mail";

export const DETAIL_CONFIG_HEADER_FOOTER = "/api/v2/hotel/header-footer/detail";
export const UPDATE_CONFIG_HEADER_FOOTER = "/api/v2/hotel/header-footer/update";
export const GET_TEAMPLATE = "/api/v2/hotel/header-footer/template";

//
export const GET_ROOM_RATE = "/api/v2/hotel/room/minimal-infor";

export const CHECK_QUANTITY = '/api/v2/hotel/room-rate/check-quantity';

export const SORT_INDEX_ROOM = '/api/v2/hotel/room/change-index';

// ket noi su

export const SU_GET_ALL = '/api/v2/hotel/ota/su/get-all';
export const SU_GET_STATUS = '/api/v2/hotel/ota/su/get-status';
export const SU_GET_IFRAME = '/api/v2/hotel/ota/su/iframe-mapping';
export const SU_OTA_GET_DETAIL = '/api/v2/hotel/ota/su/hotel';
export const SU_OTA_UPDATE_DETAIL = '/api/v2/hotel/ota/su/hotel';
export const LOG_INVENTORY = '/api/v2/hotel/log/inventory';
export const LOG_ERROR = '/api/v2/hotel/room/change-index';
export const LOG_OTA = '/api/v2/hotel/log/sync-ota';
export const LOG_DETAIL = '/api/v2/hotel/log/detail';
export const LOG_EXPAND = '/api/v2/hotel/log/sync-ota-detail';
export const SYNCOTA_UPDATE_EXTRA_SU = "/api/v2/hotel/ota/su/update-extra";
export const SU_GET_WIDGET_TOKEN = "/api/v2/hotel/ota/su/widget-token";

export const GET_AREA_CODE = '/api/v2/hotel/location/get-flag-phone-extra-code';
export const DELETE_EXTRA_SPECIAL_PRICE = '/api/v2/hotel/room-rate/mass-delete-extra-special-rate';

// mobile

export const MOBILE_AVAILABILITY = '/api/v2/hotel/mobile/room/all-availability';

export const UPDATE_STOP_SELL_DAY = '/api/v2/hotel/restriction/update-stop-cell-day';

export const RE_SYNC = '/api/v2/hotel/booking/repost';
export const RE_SYNC_UNMAP = '/api/v2/hotel/booking/repost-booking-unmap';
export const RE_SYNCS = "/api/v2/hotel/booking/multi-repost";

// gds


export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS = '/api/v2/hotel/ota/gds/get-all/not-connect';
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1H = '/api/v2/hotel/ota/ez_cms_1h/get-all/not-connect';
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1I = '/api/v2/hotel/ota/ez_cms_1i/get-all/not-connect';
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1S = '/api/v2/hotel/ota/ez_cms_1s/get-all/not-connect';
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1T = '/api/v2/hotel/ota/ez_cms_1t/get-all/not-connect';
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_GDS_1X = '/api/v2/hotel/ota/ez_cms_1x/get-all/not-connect';
export const SYNCOTA_GET_CONNECTED_GDS = '/api/v2/hotel/ota/gds/hotel/get-all';
export const SYNCOTA_GET_CONNECTED_GDS_1H = '/api/v2/hotel/ota/ez_cms_1h/hotel/get-all';
export const SYNCOTA_GET_CONNECTED_GDS_1I = '/api/v2/hotel/ota/ez_cms_1i/hotel/get-all';
export const SYNCOTA_GET_CONNECTED_GDS_1S = '/api/v2/hotel/ota/ez_cms_1s/hotel/get-all';
export const SYNCOTA_GET_CONNECTED_GDS_1T = '/api/v2/hotel/ota/ez_cms_1t/hotel/get-all';
export const SYNCOTA_GET_CONNECTED_GDS_1X = '/api/v2/hotel/ota/ez_cms_1x/hotel/get-all';
export const SYNCOTA_GET_DETAIL_GDS = "/api/v2/hotel/ota/gds/hotel";
export const SYNCOTA_GET_DETAIL_GDS_1X = "/api/v2/hotel/ota/ez_cms_1x/hotel";
export const SYNCOTA_GET_DETAIL_GDS_1I = "/api/v2/hotel/ota/ez_cms_1i/hotel";
export const SYNCOTA_GET_DETAIL_GDS_1T = "/api/v2/hotel/ota/ez_cms_1t/hotel";
export const SYNCOTA_GET_DETAIL_GDS_1S = "/api/v2/hotel/ota/ez_cms_1s/hotel";
export const SYNCOTA_GET_DETAIL_GDS_1H = "/api/v2/hotel/ota/ez_cms_1h/hotel";
export const SYNCOTA_CREATE_CONNECT_GDS = "/api/v2/hotel/ota/gds/hotel";
export const SYNCOTA_CREATE_CONNECT_GDS_1X = "/api/v2/hotel/ota/ez_cms_1x/hotel";
export const SYNCOTA_CREATE_CONNECT_GDS_1I = "/api/v2/hotel/ota/ez_cms_1i/hotel";
export const SYNCOTA_CREATE_CONNECT_GDS_1T = "/api/v2/hotel/ota/ez_cms_1t/hotel";
export const SYNCOTA_CREATE_CONNECT_GDS_1S = "/api/v2/hotel/ota/ez_cms_1s/hotel";
export const SYNCOTA_CREATE_CONNECT_GDS_1H = "/api/v2/hotel/ota/ez_cms_1h/hotel";
export const SYNCOTA_UPDATE_DETAIL_GDS = "/api/v2/hotel/ota/gds/hotel";
export const SYNCOTA_UPDATE_DETAIL_GDS_1X = "/api/v2/hotel/ota/ez_cms_1x/hotel";
export const SYNCOTA_UPDATE_DETAIL_GDS_1I = "/api/v2/hotel/ota/ez_cms_1i/hotel";
export const SYNCOTA_UPDATE_DETAIL_GDS_1S = "/api/v2/hotel/ota/ez_cms_1s/hotel";
export const SYNCOTA_UPDATE_DETAIL_GDS_1T = "/api/v2/hotel/ota/ez_cms_1t/hotel";
export const SYNCOTA_UPDATE_DETAIL_GDS_1H = "/api/v2/hotel/ota/ez_cms_1h/hotel";
export const DISCONNECTED_GDS = "/api/v2/hotel/ota/gds/update-connection";
export const DISCONNECTED_GDS_1X = "/api/v2/hotel/ota/ez_cms_1x/update-connection";
export const DISCONNECTED_GDS_1I = "/api/v2/hotel/ota/ez_cms_1i/update-connection";
export const DISCONNECTED_GDS_1T = "/api/v2/hotel/ota/ez_cms_1t/update-connection";
export const DISCONNECTED_GDS_1S = "/api/v2/hotel/ota/ez_cms_1s/update-connection";
export const DISCONNECTED_GDS_1H = "/api/v2/hotel/ota/ez_cms_1h/update-connection";
export const ROOM_RATR_OTA = "/api/v2/hotel/ota/gds/get-travelgatex-room-type";
export const ROOM_RATR_OTA_1X = "/api/v2/hotel/ota/ez_cms_1x/get-travelgatex-room-type";
// export const ROOM_RATR_OTA_1I = "/api/v2/hotel/ota/ez_cms_1i/get-travelgatex-room-type";
export const ROOM_RATR_OTA_1T = "/api/v2/hotel/ota/ez_cms_1t/get-travelgatex-room-type";
export const ROOM_RATR_OTA_1S = "/api/v2/hotel/ota/ez_cms_1s/get-travelgatex-room-type";
export const ROOM_RATR_OTA_1H = "/api/v2/hotel/ota/ez_cms_1h/get-travelgatex-room-type";
export const ROOM_RATR_OTA_1I = "/api/v2/hotel/ota/ez_cms_1i/get-room-plan-oneinventory";

// chain

export const GET_CHAIN_INFO = "/api/v2/hotel/chain/chain-info";
export const UPDATE_CHAIN_INFO = "/api/v2/hotel/chain/chain-update";
export const GET_CHAIN_TYPE = "/api/v2/hotel/chain/chain-type";
export const GET_ALL_TRAVEL_AGENT = "/api/v2/hotel/chain/agent/agent-list";
export const REMOVE_TRAVEL_AGENT = "/api/v2/hotel/chain/agent/agent-delete";
export const GET_CHAIN_TRAVEL_AGENT_INFO = "/api/v2/hotel/chain/agent/agent-detail";
export const GET_HOTE_BY_CHAIN = "/api/v2/hotel/chain/agent/get-hotel-by-chain";
export const UPDATE_AGENT_CHAIN = "/api/v2/hotel/chain/agent/agent-update";
export const CREATE_AGENT_CHAIN = "/api/v2/hotel/chain/agent/agent-creat";
export const GET_ALL_ROOM_CHAIN = "/api/v2/hotel/chain/room/get-all";
export const GET_DETAIL_ROOM_CHAIN = "/api/v2/hotel/chain/room/detail";
export const DELETE_ROOM_CHAIN = "/api/v2/hotel/chain/room/delete";
export const UPDATE_STATUS_AGENT_CHAIN = "/api/v2/hotel/chain/agent/change-status";


export const CREATE_ROOM_CHAIN = "/api/v2/hotel/chain/room/create";
export const UPDATE_ROOM_CHAIN = "/api/v2/hotel/chain/room/update";
export const UPDATE_AMENITIES_ROOM_CHAIN = "/api/v2/hotel/chain/room/update-amenity";
export const UPDATE_STATUS_ROOM_CHAIN = "/api/v2/hotel/chain/room/update-status";

export const GET_ALL_RATE_PLAN_CHAIN = "/api/v2/hotel/chain/plan/get-all";
export const GET_RATE_PLAN_CHAIN_DETAIL = "/api/v2/hotel/chain/plan/detail";

export const CREATE_RATE_PLAN_CHAIN = "/api/v2/hotel/chain/plan/create";
export const UPDATE_RATE_PLAN_CHAIN = "/api/v2/hotel/chain/plan/update";
export const UPDATE_STATUS_RATE_PLAN_CHAIN = "/api/v2/hotel/chain/plan/update-status";
export const DELETE_RATE_PLAN_CHAIN = "/api/v2/hotel/chain/plan/delete";

export const ALL_LOGS_CHAIN = "/api/v2/hotel/log/chain";

export const GET_COUNTRY = "/api/v2/hotel/info/get-country";

export const GET_ALL_TRAVEL_AGENT_HOTEL = "/api/v2/hotel/agent/agent-list";
export const REMOVE_TRAVEL_AGENT_HOTEL = "/api/v2/hotel/agent/agent-delete";
export const GET_TRAVEL_AGENT_HOTEL_INFO = "/api/v2/hotel/agent/agent-detail";
export const UPDATE_AGENT_HOTEL = "/api/v2/hotel/agent/agent-update";
export const CREATE_AGENT_HOTEL = "/api/v2/hotel/agent/agent-creat";
export const UPDATE_STATUS_AGENT_HOTEL = "/api/v2/hotel/agent/change-status";


// chain service

export const CHAIN_GET_LIST_SERVICE = "/api/v2/hotel/chain/service/list-service";
export const CHAIN_SORT_LIST_SERVICE = "/api/v2/hotel/chain/service/change-index";
export const CHAIN_UPDATE_STATUS_SERVICE = "/api/v2/hotel/chain/service/change-status";
export const CHAIN_DELETE_SERVICE = "/api/v2/hotel/chain/service/delete";
export const CHAIN_DETAIL_SERVICE = "/api/v2/hotel/chain/service/detail";
export const CHAIN_UPDATE_SERVICE = "/api/v2/hotel/chain/service/update";
export const CHAIN_CREATE_SERVICE = "/api/v2/hotel/chain/service/create";
export const CHAIN_CHECK_SERVICE_CODE = "/api/v2/hotel/chain/service/check";
export const CHAIN_CHECK_SPECIAL_DAYS_PRICE = "/api/v2/hotel/chain/service/check-special-service";
export const CHAIN_UPDATE_STATUS_SERVICE_ALL = "/api/v2/hotel/chain/service/change-status-services";
export const CHAIN_DELETE_SERVICE_LIST = "/api/v2/hotel/chain/service/delete-services";
export const CHAIN_GET_ALL_UNIT = "/api/v2/hotel/chain/service/unit";

export const GET_HOTEL_LIST_BY_CHAIN_LIST = "/api/v2/hotel/chain/agent/get-hotel-list-by-chain-list";

export const RE_SYNC_CHAIN = "/api/v2/hotel/chain/booking/repost";

export const RE_SYNCS_CHAIN = "/api/v2/hotel/chain/booking/multi-repost";

export const GET_OTA_BY_CHAIN = "/api/v2/hotel/chain/get-ota-by-chain";
export const GET_ALL_OTA_BY_CHAIN = "/api/v2/hotel/chain/get-all-ota-by-chain";
export const UPDATE_RATE_BY_OTA = "/api/v2/hotel/chain/room-rate/bulk-update";
export const GET_ALL_OTA_ASSIGN = "/api/v2/hotel/chain/get-ota-by-hotel";
export const GET_OTA_ASSIGN = "/api/v2/hotel/chain/get-ota-assign-by-hotel";
export const GET_LIST_LANGS = "/api/v2/hotel/language/get-hotel-lang";



// siteMinder


export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_SITE_MINDER = '/api/v2/hotel/ota/siteminder/get-all/not-connect';
export const SYNCOTA_GET_CONNECTED_SITE_MINDER = '/api/v2/hotel/ota/siteminder/hotel/get-all';
export const SYNCOTA_GET_DETAIL_SITE_MINDER = "/api/v2/hotel/ota/siteminder/hotel";
export const SYNCOTA_CREATE_CONNECT_SITE_MINDER = "/api/v2/hotel/ota/siteminder/hotel";
export const SYNCOTA_UPDATE_DETAIL_SITE_MINDER = "/api/v2/hotel/ota/siteminder/hotel";
export const DISCONNECTED_SITE_MINDER = "/api/v2/hotel/ota/siteminder/update-connection";



// combo
export const GET_ALL_SERVICE_COMBO = '/api/v2/hotel/service-static/list-service-static';
export const DELETE_SERVICE_STATIC = '/api/v2/hotel/service-static/delete';
export const UPDATE_STATUS_SERVICE_STATIC = '/api/v2/hotel/service-static/change-status';
export const DETAIL_SERVICE_STATIC = '/api/v2/hotel/service-static/detail';
export const CHECK_SERVICE_CODE_STATIC = '/api/v2/hotel/service-static/detail';
export const CREATE_SERVICE_STATIC = '/api/v2/hotel/service-static/create';
export const UPDATE_SERVICE_STATIC = '/api/v2/hotel/service-static/update';

export const GET_ROOM_RATE_PACKAGE = '/api/v2/hotel/room-rate-package/list-room-rate-package';
export const CREATE_ROOM_RATE_PACKAGE = '/api/v2/hotel/room-rate-package/create';
export const REMOVE_ROOM_RATE_PACKAGE = '/api/v2/hotel/room-rate-package/delete';
export const CREATE_ROOM_RATE_PACKAGE_LIST = '/api/v2/hotel/room-rate-package/create-list';
export const UPDATE_ROOM_RATE_PACKAGE_LIST = '/api/v2/hotel/room-rate-package/edit-list';
export const ROOM_RATE_PAACKAGE_WEEKLY = '/api/v2/hotel/room-rate-package/list-room-rate-package-min-room-rate';

export const ROOM_RATE_PACKAGE_DAILY = '/api/v2/hotel/room-rate-package-specials/list-room-rate-package-specials';
export const UPDATE_ROOM_RATE_PACKAGE_LIST_DAILY = '/api/v2/hotel/room-rate-package-specials/edit-list';
export const ROOM_RATE_PACKAGE_SPECIAL = '/api/v2/hotel/room-rate-package-special/list-room-rate-package-special';

// master rate
export const GET_PRODUCE_MASTER = "/api/v2/hotel/master-rate/get-master";
export const GET_PRICE_PRODUCE_MASTER_RATE = "/api/v2/hotel/master-rate/get-price";
export const GET_ROOM_RATE_WITH_FORMULA = "/api/v2/hotel/master-rate/get-room-rate-with-formula";
export const SAVE_FORMULA_ITEM_MASTER_RATE = "/api/v2/hotel/master-rate/setup-formula";
export const GET_ALL_ROOM_RATE_WITH_FORMULA = "/api/v2/hotel/master-rate/get-room-rate";
export const REMOVE_FORMULA_ITEM = "/api/v2/hotel/master-rate/delete-formula";
export const GET_ROOM_RATE_WITH_FORMULA_DATE = "/api/v2/hotel/master-rate/get-formula-by-date-range";
export const UPDATE_ROOM_RATE_FORMULA_DATE = "/api/v2/hotel/master-rate/setup-formula-by-date-range";
export const GET_ROOM_RATE_DERIVATIONS_DENOMINATOR_LIST = "/api/v2/hotel/master-rate/list-template";
export const GET_ROOM_RATE_LIST_FORMULA = "/api/v2/hotel/master-rate/list-formula";
// dynamic pricing

export const GET_ALL_DYNAMIC = "/api/v2/hotel/dynamicpricing/get-all";
export const DETAIL_DYNAMIC = "/api/v2/hotel/dynamicpricing/detail";
export const UPDATE_DYNAMIC = "/api/v2/hotel/dynamicpricing/update";
export const CREATE_DYNAMIC = "/api/v2/hotel/dynamicpricing/create";
export const REMOVE_DYNAMIC = "/api/v2/hotel/dynamicpricing/delete";
export const GET_PRODUCT_DYNAMIC = "/api/v2/hotel/dynamicpricing/getProduct";
export const UPDATE_STATUS_DYNAMIC = "/api/v2/hotel/dynamicpricing/update-status";
export const SORT_DYNAMIC = "/api/v2/hotel/dynamicpricing/update-index";
export const DETAIL_SCHEDULE_DYNAMIC = "/api/v2/hotel/dynamicpricing/schedule/detail";
export const UPDATE_SCHEDULE_DYNAMIC = "/api/v2/hotel/dynamicpricing/schedule/create";
// ezBe 

export const SYNCOTA_GET_DETAIL_BE = "/api/v2/hotel/ota/be/hotel";
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE = "/api/v2/hotel/ota/be/get-all/not-connect";
export const SYNCOTA_GET_CONNECTED_BE = "/api/v2/hotel/ota/be/hotel/get-all";
export const SYNCOTA_CREATE_CONNECT_BE = "/api/v2/hotel/ota/be/hotel";
// app
export const SYNCOTA_GET_DETAIL_BE_APP = "/api/v2/hotel/ota/ez_api_app/hotel";
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_APP = "/api/v2/hotel/ota/ez_api_app/get-all/not-connect";
export const SYNCOTA_GET_CONNECTED_BE_APP = "/api/v2/hotel/ota/ez_api_app/hotel/get-all";
export const SYNCOTA_CREATE_CONNECT_BE_APP = "/api/v2/hotel/ota/ez_api_app/hotel";
// kios
export const SYNCOTA_GET_DETAIL_BE_KIOS = "/api/v2/hotel/ota/ez_api_kiosk/hotel";
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_KIOS = "/api/v2/hotel/ota/ez_api_kiosk/get-all/not-connect";
export const SYNCOTA_GET_CONNECTED_BE_KIOS = "/api/v2/hotel/ota/ez_api_kiosk/hotel/get-all";
export const SYNCOTA_CREATE_CONNECT_BE_KIOS = "/api/v2/hotel/ota/ez_api_kiosk/hotel";
// pms
export const SYNCOTA_GET_DETAIL_BE_PMS = "/api/v2/hotel/ota/ez_api_pms/hotel";
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_BE_PMS = "/api/v2/hotel/ota/ez_api_pms/get-all/not-connect";
export const SYNCOTA_GET_CONNECTED_BE_PMS = "/api/v2/hotel/ota/ez_api_pms/hotel/get-all";
export const SYNCOTA_CREATE_CONNECT_BE_PMS = "/api/v2/hotel/ota/ez_api_pms/hotel";

// Booking group
export const GET_AL_BOOKINGS_GROUP_BY_HOTEL = '/api/v2/hotel/chain/booking/get-all-bookings-group-by-hotel';
export const GET_TOTAL_BOOKINGS_GROUP_BY_HOTEL = '/api/v2/hotel/chain/booking/get-total-bookings-group-by-hotel';
export const EXPORT_BOOKINGS_GROUP_BY_HOTEL = '/api/v2/hotel/chain/booking/export-bookings-group-by-hotel';
export const EXPORT_PDF_BOOKINGS_GROUP_BY_HOTEL = '/api/v2/hotel/chain/booking/export-bookings-group-by-hotel-pdf';

// Group
export const BOOKING_GROUP_GET_ALL = '/api/v2/hotel/booking-group/search';
export const GET_ALL_GROUP_PROFILE = '/api/v2/hotel/booking-group/get-all-group-profile';
export const DELETE_GROUP_PROFILE = '/api/v2/hotel/booking-group/delete-group-profile';
export const GET_DETAIL_GROUP_PROFILE = '/api/v2/hotel/booking-group/detail-group-profile';
export const GET_BOOOKING_GROUPS = '/api/v2/hotel/booking-group/booking-groups';
export const CREATE_GROUP_PROFILE = '/api/v2/hotel/booking-group/create-group-profile';
export const UPDATE_GROUP_PROFILE = '/api/v2/hotel/booking-group/update-group-profile';
export const GET_DETAIL_BOOKING_GROUP = '/api/v2/hotel/booking-group/detail';
export const UPDATE_BOOKING_GROUP = '/api/v2/hotel/booking-group/update';
export const BOOKING_GROUP_EXPORT = '/api/v2/hotel/booking-group/createExcel';
export const SEARCH_GROUP_PROFILE = '/api/v2/hotel/booking-group/search-group-profile';
export const GET_TITLE = '/api/v2/hotel/booking-group/get-all-title';

// category
export const GET_RATE_CATEGORY_LIST = '/api/v2/hotel/category/rate-category-list';
export const CREATE_RATE_CATEGORY = '/api/v2/hotel/category/rate-category-creat';
export const UPDATE_RATE_CATEGORY = '/api/v2/hotel/category/rate-category-update';
export const GET_RATE_CATEGORY_DETAIL = '/api/v2/hotel/category/rate-category-detail';
export const RATE_CATEGORY_CHANGE_STATUS = '/api/v2/hotel/category/rate-category-change-status';
export const DELETE_CATEGORY = '/api/v2/hotel/category/rate-category-delete';
export const CHANGE_INDEX_RATE_CATEGORY = '/api/v2/hotel/category/change-index';

export const GET_ROOM_CATEGORY_LIST = '/api/v2/hotel/room-category/get-all';
export const CREATE_ROOM_CATEGORY = '/api/v2/hotel/room-category/create';
export const UPDATE_ROOM_CATEGORY = '/api/v2/hotel/room-category/update';
export const GET_ROOM_CATEGORY_DETAIL = '/api/v2/hotel/room-category/detail';
export const ROOM_CATEGORY_CHANGE_STATUS = '/api/v2/hotel/room-category/change-status';
export const DELETE_ROOM_CATEGORY = '/api/v2/hotel/room-category/delete';
export const CHANGE_INDEX_ROOM_CATEGORY = '/api/v2/hotel/room-category/change-index';

export const GET_CHAIN_RATE_CATEGORY_LIST = '/api/v2/hotel/chain/category/rate-category-list';
export const CREATE_CHAIN_RATE_CATEGORY = '/api/v2/hotel/chain/category/rate-category-creat';
export const UPDATE_CHAIN_RATE_CATEGORY = '/api/v2/hotel/chain/category/rate-category-update';
export const GET_CHAIN_RATE_CATEGORY_DETAIL = '/api/v2/hotel/chain/category/rate-category-detail';
export const RATE_CHAIN_CATEGORY_CHANGE_STATUS = '/api/v2/hotel/chain/category/rate-category-change-status';
export const DELETE_CHAIN_CATEGORY = '/api/v2/hotel/chain/category/rate-category-delete';
// C trip

export const SYNCOTA_GET_DETAIL_GDS_CTRIP = '/api/v2/hotel/ota/ez_cms_1t/hotel/ctrip';
export const SYNCOTA_UPDATE_DETAIL_GDS_CTRIP = "/api/v2/hotel/ota/ez_cms_1t/hotel/ctrip";
// sort

export const SORT_INDEX_PLAN = '/api/v2/hotel/plan/change-index';



export const GET_CHAIN_ROOM_CATEGORY_LIST = '/api/v2/hotel/chain-room-category/get-all';
export const CREATE_CHAIN_ROOM_CATEGORY = '/api/v2/hotel/chain-room-category/create';
export const UPDATE_CHAIN_ROOM_CATEGORY = '/api/v2/hotel/chain-room-category/update';
export const GET_CHAIN_ROOM_CATEGORY_DETAIL = '/api/v2/hotel/chain-room-category/detail';
export const CHAIN_ROOM_CATEGORY_CHANGE_STATUS = '/api/v2/hotel/chain-room-category/status';
export const DELETE_CHAIN_ROOM_CATEGORY = '/api/v2/hotel/chain-room-category/delete';

// pms rate

export const GET_PMS_RATE = '/api/v2/hotel/chain/room-rate';
export const GET_DETAIL_PMS_RATE = '/api/v2/hotel/chain/room-rate/detail';
export const UPDATE_PMS_RATE = '/api/v2/hotel/chain/room-rate/update';
export const DELETE_RATE_PMS_RATE = '/api/v2/hotel/chain/room-rate/delete';

export const GET_RATE_PLAN_BY_CATEGORY = '/api/v2/hotel/room/rate-plan-by-rate-category';
export const GET_ROOM_TYPE_BY_CATEGORY = '/api/v2/hotel/room/room-type-by-room-category';


// dashboard

export const GET_PROSESS_DASHBOARD = '/api/v2/hotel/dashboard-roomrate/get-all';
export const UPDATE_PROSESS_DASHBOARD = '/api/v2/hotel/dashboard-roomrate/update';
export const IGRONE_PROSESS_DASHBOARD = '/api/v2/hotel/dashboard-roomrate/igrone';

export const UPDATE_SPECIAL_PRICE_ROOM = '/api/v2/hotel/room/update-room-type-special';
// Dynamic restriction

export const GET_ALL_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/get-all";
export const DETAIL_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/detail";
export const UPDATE_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/update";
export const CREATE_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/create";
export const REMOVE_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/delete";
export const GET_PRODUCT_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/getProduct";
export const UPDATE_STATUS_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/update-status";
export const SORT_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/update-index";
export const DETAIL_SCHEDULE_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/schedule/detail";
export const UPDATE_SCHEDULE_DYNAMIC_RESTRICTION = "/api/v2/hotel/dynamic-restriction/schedule/create";


export const GET_ROOM_TYPE_BY_CHAIN = "/api/v2/hotel/chain/room-type-by-chain";
export const GET_RATE_PLAN_BY_CHAIN = "/api/v2/hotel/chain/rate-plan-by-chain";

export const DASHBOARD_RMS = "/api/v2/hotel/dashboard-rms/get-all";
export const DASHBOARD_RMS_STOP_SELL = "/api/v2/hotel/dashboard-rms/get-all-restriction";
export const DASHBOARD_RMS_DETAIL_DAY = "/api/v2/hotel/dashboard-rms/detail";
export const DASHBOARD_RMS_DETAIL_DAY_STOP_SELL = "/api/v2/hotel/dashboard-rms/detail-restriction";


// Ban phong ota

export const GET_ROOM_DEFAULT_WITH_ALL_RELATION = "/api/v2/hotel/room/all-sale-room";
export const GET_RESTRICTION_BY_ROOM_RATE_API = "/api/v2/hotel/room/get-restriction-room-rate";
// channex
export const CHANNEX_GET_ALL = '/api/v2/hotel/ota/channex/get-all';
export const CHANNEX_GET_STATUS = '/api/v2/hotel/ota/channex/get-status';
export const CHANNEX_GET_IFRAME = '/api/v2/hotel/ota/channex/iframe-mapping';
export const CHANNEX_OTA_GET_DETAIL = '/api/v2/hotel/ota/channex/hotel';
export const CHANNEX_OTA_UPDATE_DETAIL = '/api/v2/hotel/ota/channex/hotel';
export const SYNCOTA_UPDATE_EXTRA_CHANNEX = "/api/v2/hotel/ota/channex/update-extra";

// Ban phong ota
export const GET_ALL_CHAIN_SEGMENT = "/api/v2/hotel/chain/segment-all";
export const GET_ALL_HOTEL_SEGMENT = "/api/v2/hotel/info/segment/get-all";

export const GET_ALL_OTA_GROUP = "/api/v2/hotel/ota-group/get-all";

export const DASHBOARD_RMS_DETAIL_DAY_DU = "/api/v2/hotel/dashboard-rms/all-booking-day-use";
export const DASHBOARD_RMS_DETAIL_DAY_A = "/api/v2/hotel/dashboard-rms/all-booking";

export const CREATE_TOKEN_EZPAY = "/api/v2/hotel/payment-method/create-token";

// module
export const GET_MODULE_ACCESS = "/api/v2/hotel/info/module";
export const GET_ALL_EZ_PROMOTION = "/api/v2/hotel/promotion/get-promotions";

// pricelab
export const PRICELAB_GET_ALL = '/api/v2/hotel/ota/pricelabs/get-all';
export const PRICELAB_GET_STATUS = '/api/v2/hotel/ota/pricelabs/get-status';
export const PRICELAB_GET_IFRAME = '/api/v2/hotel/ota/pricelabs/iframe-mapping';
export const PRICELAB_OTA_GET_DETAIL = '/api/v2/hotel/ota/pricelabs/hotel';
export const PRICELAB_OTA_UPDATE_DETAIL = '/api/v2/hotel/ota/pricelabs/hotel';
export const PRICELAB_SYNC = '/api/v2/hotel/ota/pricelabs/get-data';

export const CHANNEX_SYNC_DATA = '/api/v2/hotel/ota/channex/sync-data';
export const SU_SYNC_DATA = '/api/v2/hotel/ota/su/sync-data';
export const SITEMIDER_SYNC_DATA = '/api/v2/hotel/ota/siteminder/sync-data';
export const PRICELABS_SYNC_DATA = '/api/v2/hotel/ota/pricelabs/sync-data';
export const EZ_CMS_1T_SYNC_DATA = '/api/v2/hotel/ota/ez_cms_1t/sync-data';
export const EZ_CMS_1I_SYNC_DATA = '/api/v2/hotel/ota/ez_cms_1i/sync-data';

// language
export const LANGUAGE_ALL = '/api/v2/hotel/language/get-all';

//get version
export const GET_VERSION = '/api/v2/hotel/chain/version';

// warning method
export const WARNING_METHOD = '/api/v2/hotel/hotel-warning/general-info';
export const UPDATE_WARNING_METHOD = '/api/v2/hotel/hotel-warning/update';

//traveloka
export const TRAVELOKA_SYNC_DATA = '/api/v2/hotel/ota/traveloka/sync-data';
export const SYNCOTA_GET_ALL_OTA_NOT_CONNECT_TRAVELOKA = '/api/v2/hotel/ota/traveloka/get-all/not-connect';
export const SYNCOTA_GET_CONNECTED_TRAVELOKA = '/api/v2/hotel/ota/traveloka/hotel/get-all';
export const SYNCOTA_GET_DETAIL_TRAVELOKA = "/api/v2/hotel/ota/traveloka/hotel";
export const SYNCOTA_CREATE_CONNECT_TRAVELOKA = "/api/v2/hotel/ota/traveloka/hotel";
export const SYNCOTA_UPDATE_DETAIL_TRAVELOKA = "/api/v2/hotel/ota/traveloka/hotel";
export const DISCONNECTED_TRAVELOKA = "/api/v2/hotel/ota/traveloka/update-connection";
export const GET_OTA_ROOM_TRAVELOKA = "/api/v2/hotel/ota/traveloka/ota-room";
export const SYNCOTA_UPDATE_EXTRA_TRAVELOKA = "/api/v2/hotel/ota/traveloka/update-extra";

//staah max
export const STAAH_MAX_GET_ALL = '/api/v2/hotel/ota/staah_max/get-all';
export const STAAH_MAX_GET_STATUS = '/api/v2/hotel/ota/staah_max/get-status';
export const STAAH_MAX_GET_IFRAME = '/api/v2/hotel/ota/staah_max/iframe-mapping';
export const STAAH_MAX_OTA_GET_DETAIL = '/api/v2/hotel/ota/staah_max/hotel';
export const STAAH_MAX_OTA_UPDATE_DETAIL = '/api/v2/hotel/ota/staah_max/hotel';
export const STAAH_MAX_GET_WIDGET_TOKEN = "/api/v2/hotel/ota/staah_max/widget-token";
export const STAAH_MAX_SYNC_DATA = '/api/v2/hotel/ota/staah_max/sync-data';
export const STAAH_MAX_UPDATE_EXTRA = "/api/v2/hotel/ota/staah_max/update-extra";